import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";

const EventLog = ({ assetId }) => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    loadLogs();
  }, []);

  const loadLogs = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/asset/${assetId}/event-logs`);
      setLogs(res.data);
    } catch (err) {
      console.error("Failed to load event logs", err);
    }
  };

  return (
    <div className="card p-3">
      <h5>Event Log</h5>

      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Added By</th>
            <th>Type</th>
            <th>Info</th>
            <th>Date</th>
          </tr>
        </thead>

        <tbody>
          {logs.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center">
                No event logs found.
              </td>
            </tr>
          ) : (
            logs.map((log) => (
              <tr key={log.log_id}>
                <td>
                  {log.first_name} {log.last_name} ({log.employee_id})
                </td>
                <td>{log.log_type}</td>
                <td>{log.log_info}</td>
                <td>{new Date(log.log_datetime).toLocaleString()}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EventLog;
